import { SenderArguments } from "@ton/ton";
import { Score, scores } from "../config/scoresConfig.js";
import getTonContract from "./getTonContract.js";

export const defaultContract = {
  getNonce: () => 0,
  getMintingInfo: () => undefined,
  mintToken: () => undefined,
  checkIsHolder: () => false,
  getNewTxHash: () => "",
  getToken: () => undefined,
  checkMintingTxStatus: () => false,
  getMintingTxParams: () => Promise<SenderArguments>,
};

export const getContract = (address: string, scoreName: Score) => {
  const scoreConfig = scores[scoreName];

  if (scoreConfig?.type === "ton" && scoreName) {
    const tonContract = getTonContract(address, scoreName);
    return tonContract;
  }

  return defaultContract;
};
